import { TABLE_TYPES } from "@/helpers/constants";
export default {
  computed: {
    showActions() {
      return this.options.actions && this.user.user_uuid !== this.person.userUUID;
    },
    /**
     * Current authorize user from redis session
     * @return {Object}
     */
    user() {
      return this.$store.state.users.user;
    }
  },
  methods: {
    addToNetwork(user) {
      this.$store.dispatch("users/createUserConnection", {
        targetUserUUID: user.userUUID
      });
    },
    removeFromNetwork(user) {
      this.$store.dispatch("users/updateUserConnection", {
        targetUserUUID: user.userUUID,
        status: 0
      });
    },
    restoreNetwork(user) {
      this.$store.dispatch("users/updateUserConnection", {
        targetUserUUID: user.userUUID,
        status: 1
      });
    },
    sendPrivateMessage(user, scrollPage = false) {
      this.$store.commit(
        "chat/setPrivateChatTarget",
        user.targetUserUUID
          ? {
              userUUID: user.targetUserUUID,
              firstName: user.user_info.firstName,
              lastName: user.user_info.lastName,
              domain: user.user_info.meta.domain
            }
          : {
              userUUID: user.userUUID,
              firstName: user.firstName,
              lastName: user.lastName,
              domain: user.domain
            }
      );
      this.openTabs(["#tab-chat", "#tab-chat-private"], scrollPage);
      this.$store.commit("chat/changeChatMode", { mode: "PRIVATE", scrollPage });
    },
    openTabs(tabNames, doScroll) {
      tabNames.forEach((tab, index) => {
        setTimeout(() => {
          this.$root.$emit("activateTab", tab);
        }, 300 * index);
      });

      if (doScroll) {
        this.$scrollTo("#people-chat-container");
      }
    },
    editProfile() {
      this.openTabs(["#me"]);
      this.$store.commit("users/changeUserProfileTabState", "Edit");
    },
    isCurrentUser(user) {
      return this.user.user_uuid === user.userUUID;
    },
    /**
     * Check that networking enabled for current user
     * @param user {Object}
     * @return {boolean}
     */
    isNetworkingEnabledForUser(user) {
      let table = this.$store.getters["tables/tableByUser"](user);
      return (
        this.$store.getters["tables/userTable"].TABLE_TYPE !== TABLE_TYPES.PUBLIC_GALLERY &&
        table &&
        table.TABLE_TYPE !== TABLE_TYPES.PUBLIC_GALLERY
      );
    }
  }
};
